var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-charts',{ref:"map",attrs:{"options":_vm.option,"init-options":_vm.initOptions,"autoresize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }